import React, { useState, useEffect } from "react";
import CommonStyle from "../Styles/Common.module.css";
import { getLocationDetail, getCategoryId, ClientRequestAPI, getCategoryLocation } from "../../services/routes.services";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

const ClientRequest = ({ onClose, authToken }) => {
  const [locationContent, setLocationContent] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [locationValue, setLocationValue] = useState("");
  const [categoryValue, setCategoryValue] = useState([]);
  const [files, setFiles] = useState([]); // ✅ single source for multiple files
  const [ locationData, setLocationData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    whatsapp: "",
    role: "",
    city: "",
    l_type: "",
    days: "",
    notes: "",
    budget: "",
    non_negotiable: "",
    query: "",
    project: "",
    startDate: null,
    endDate: null,
  });

  // Fetch cities
  useEffect(() => {
    getLocationDetail()
      .then((res) => {
        const cityData = res?.data?.[0]?.location || [];
        setLocationContent(cityData);
      })
      .catch((error) => {
        console.error("Failed to load locations:", error);
      });
  }, []);
useEffect(() => {
  const fetchLocationData = async () => {
    try {
      const res = await getCategoryLocation();
      const response = res?.data || [];
      setLocationData(response[0].category);
    } catch (error) {
      console.error("Failed to load locations:", error);
    }
  };

  fetchLocationData();
}, []);
  console.log(locationData)
//  const handleCategory = (categoryId) => {
//     setCategoryValue(categoryId);
//     setFormData((prev) => ({ ...prev, l_type: categoryId }));
//   };
  // Fetch categories by city
  // const handleLocation = (locationId) => {
  //   setLocationValue(locationId);
  //   setFormData((prev) => ({ ...prev, city: locationId }));
  //   setCategoryValue([]);
  //   setCategoryList([]);

  //   getCategoryId(locationId)
  //     .then((res) => {
  //       const categoryData = res?.data?.[0]?.category || [];
  //       setCategoryList(categoryData);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching categories:", err);
  //       setCategoryList([]);
  //     });
  // };

  // Input change handler
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "radio" ? value : value,
    }));
  };


  // const handleFileChange = (e) => {
  //   setFiles(Array.from(e.target.files)); // converts FileList → Array
  // };

  const clientRequestHandel = async (e) => {
    e.preventDefault();

    try {
      const postData = new FormData();
      Object.entries(formData).forEach(([key, val]) => {
        if (val !== null && val !== undefined && val !== "") postData.append(key, val);
      });

    if (categoryValue && categoryValue.length > 0) {
    postData.append("l_type", categoryValue.map(Number).join(","));
    }
      if (files.length > 0) {
        files.forEach((file) => postData.append("image[]", file));
      }

      if (formData.startDate && formData.endDate) {
        const timeline = `${formData.startDate.toISOString().split("T")[0]} to ${formData.endDate
          .toISOString()
          .split("T")[0]}`;
        postData.append("timeline", timeline);
      }

      // fatch img
      for (let [key, val] of postData.entries()) {
        console.log("fatch img ", key, val);
      }
      console.log(categoryValue)
      const response = await ClientRequestAPI(postData, authToken);
      console.log("✅ API Response:", response.data);
      onClose();
      alert("Form submitted successfully!");
      
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form!");
    }
  };

  return (
    <div className="popupOverLay locationForm">
      <div className="popupContainer">
        <span className="closePup" onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M23.6795 10.5306L10.0306 24.1795M10.0306 10.5306L23.6795 24.1795M32.2101 17.355C32.2101 25.8354 25.3354 32.7101 16.855 32.7101C8.37469 32.7101 1.5 25.8354 1.5 17.355C1.5 8.87469 8.37469 2 16.855 2C25.3354 2 32.2101 8.87469 32.2101 17.355Z"
              stroke="black"
              strokeWidth="2.05917"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>

        <h5>Easyrecce - Location Requirement Form</h5>

        <form className="popFormStyle" onSubmit={clientRequestHandel}>
          <h5>Contact Details</h5>

          <div className="inputBox">
            <label>Name:</label>
            <input type="text" name="name" placeholder="Name" className={CommonStyle.inputStyle} value={formData.name} onChange={handleChange} required />
          </div>

          <div className="inputBox">
            <label>Email:</label>
            <input type="email" name="email" placeholder="Email" className={CommonStyle.inputStyle} value={formData.email} onChange={handleChange} required />
          </div>

          <div className="inputBox">
            <label>WhatsApp Number:</label>
            <input type="number" name="whatsapp" placeholder="WhatsApp Number" className={CommonStyle.inputStyle} value={formData.whatsapp} onChange={handleChange} required/>
          </div>

          <div className="inputBox">
            <label>Designation / Role:</label>
            <input type="text" name="role" placeholder="Designation / Role" className={CommonStyle.inputStyle} value={formData.role} onChange={handleChange} required />
          </div>

          <h5>Location Requirement</h5>

          <div className="inputBox">
            <label>City / Region of Requirement:</label>
            <input type="text" name="city" placeholder="City" className={CommonStyle.inputStyle} value={formData.city} onChange={handleChange} required />
            {/* <select value={locationValue} onChange={(e) => handleLocation(e.target.value)} className={CommonStyle.inputStyle} name="city" required>
              <option value="">Select City</option>
              {locationContent.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.title}
                </option>
              ))}
            </select> */}
            
          </div>

          <div className="inputBox">
            <label>Location Type:</label>
            {/* <select value={categoryValue} onChange={(e) => handleCategory(e.target.value)} className={CommonStyle.inputStyle} name="l_type" required > <option value="">Select Location Type</option> {categoryList.map((loc) => ( <option key={loc.id} value={loc.id}> {loc.title} </option> ))} </select> */}
            <Select
              isMulti
              className={'multiValue ' + CommonStyle.inputStyle}
              options={locationData.map((loc) => ({ value: loc.id, label: loc.title }))}
              value={locationData
                .filter((loc) => categoryValue.includes(loc.id))
                .map((loc) => ({ value: loc.id, label: loc.title }))}
              onChange={(selected) => setCategoryValue(selected.map((item) => item.value))}
            />
          </div>

          <div className="inputBox">
            <label>Number of Shoot Days:</label>
            <input type="number" name="days" placeholder="Number of Shoot Days" className={CommonStyle.inputStyle} value={formData.days} onChange={handleChange} />
          </div>

          <div className="inputBox">
            <label>Desired Shoot Timeline:</label>
            <DatePicker
              selected={formData.startDate}
              onChange={(dates) => {
                const [start, end] = dates;
                setFormData((prev) => ({
                  ...prev,
                  startDate: start,
                  endDate: end,
                }));
              }}
              startDate={formData.startDate}
              endDate={formData.endDate}
              selectsRange
              placeholderText="Select timeline"
              className={CommonStyle.inputStyle}
              dateFormat="dd MMM yyyy"
              required
            />
          </div>

          <div className="inputBox">
            <label>Location Brief:</label>
            <textarea name="notes" placeholder="Location Brief" className={CommonStyle.inputStyle} value={formData.notes} onChange={handleChange} />
              
          </div>

          <div className="inputBox">
            <label>Budget:</label>
            <input type="text" name="budget" placeholder="Budget" className={CommonStyle.inputStyle} value={formData.budget} onChange={handleChange} />
          </div>

          <div className="inputBox">
            <label>Non-Negotiable Location Requirements:</label>
            <input type="text" name="non_negotiable" placeholder="Non-Negotiable Requirements" className={CommonStyle.inputStyle} value={formData.non_negotiable} onChange={handleChange}/>
          </div>

          <div className="inputBox">
            <label>Upload Reference Image:</label>
            <input
                type="file"
                name="image"
                multiple
                accept="image/*"
                onChange={(e) => setFiles(Array.from(e.target.files))}
                className={CommonStyle.inputStyle}
                />
          </div>

          <h5>Additional Services</h5>
          <div className="inputBox">
            <label>Would you like EasyRecce to help with a production budget?</label>
            <div>
              <input type="radio" name="query" value="yes" checked={formData.query === "yes"} onChange={handleChange} /> Yes
            </div>
            <div>
              <input type="radio" name="query" value="no" checked={formData.query === "no"} onChange={handleChange} /> No
            </div>
          </div>

          <div className="inputBox">
            <label>Would you like EasyRecce to assign a Line Producer (LP)?</label>
            <div>
              <input type="radio" name="project" value="yes" checked={formData.project === "yes"} onChange={handleChange}/>{" "}Yes
            </div>
            <div>
              <input type="radio" name="project" value="no" checked={formData.project === "no"} onChange={handleChange}/>{" "}No
            </div>
          </div>
          <button className="submitBtn" type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ClientRequest;
